import { Alert, Typography } from "antd";
import { SurveyPage, SurveyElementBase } from "survey-react-ui";

export class Page extends SurveyPage {
  protected renderTitle() {
    if (!this.page.title) return <></>;
    return (
      <Typography.Title
        level={3}
        style={{ fontWeight: 700, marginTop: "1.2rem" }}
      >
        {this.page.title}
      </Typography.Title>
    );
  }

  protected renderDescription() {
    return this.page.description ? (
      <Alert
        description={SurveyElementBase.renderLocString(
          this.page.locDescription,
        )}
        type="info"
        style={{ marginBottom: 20 }}
      />
    ) : null;
  }
}
